import type { IconProps } from '@/types/general'

export const Close = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26"
		height="22"
		viewBox="0 0 26 22"
		fill="currentColor"
		className={props.className}
	>
		<g clipPath="url(#clip0_153_14310)">
			<path
				d="M22.6763 0.503577C22.4319 0.509348 22.1998 0.611564 22.0305 0.787909L13.1235 9.69497L4.21642 0.787909C4.13017 0.69909 4.02698 0.628481 3.91295 0.580262C3.79892 0.532044 3.67638 0.507196 3.55258 0.507191C3.36843 0.507236 3.18849 0.56222 3.03577 0.665107C2.88305 0.767994 2.7645 0.914106 2.69528 1.08475C2.62607 1.25539 2.60934 1.4428 2.64723 1.62301C2.68513 1.80321 2.77593 1.96801 2.90801 2.09632L11.8151 11.0034L2.90801 19.9104C2.81921 19.9957 2.74831 20.0978 2.69947 20.2108C2.65064 20.3238 2.62483 20.4454 2.62358 20.5685C2.62233 20.6916 2.64565 20.8137 2.69219 20.9277C2.73872 21.0417 2.80752 21.1452 2.89457 21.2323C2.98162 21.3193 3.08516 21.3881 3.19914 21.4347C3.31311 21.4812 3.43522 21.5045 3.55832 21.5033C3.68142 21.502 3.80303 21.4762 3.91603 21.4274C4.02904 21.3785 4.13116 21.3076 4.21642 21.2188L13.1235 12.3118L22.0305 21.2188C22.1158 21.3076 22.2179 21.3785 22.3309 21.4274C22.4439 21.4762 22.5655 21.502 22.6886 21.5033C22.8117 21.5045 22.9338 21.4812 23.0478 21.4347C23.1618 21.3881 23.2653 21.3193 23.3524 21.2323C23.4394 21.1452 23.5082 21.0417 23.5548 20.9277C23.6013 20.8137 23.6246 20.6916 23.6234 20.5685C23.6221 20.4454 23.5963 20.3238 23.5475 20.2108C23.4986 20.0978 23.4277 19.9957 23.3389 19.9104L14.4319 11.0034L23.3389 2.09632C23.4735 1.96717 23.5659 1.80039 23.604 1.61782C23.6421 1.43526 23.6242 1.24543 23.5525 1.07324C23.4809 0.901046 23.3589 0.754517 23.2025 0.652862C23.0462 0.551208 22.8628 0.499172 22.6763 0.503577Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			{/* biome-ignore lint/correctness/useUniqueElementIds: SVG clipPath ID is scoped to this component */}
			<clipPath id="clip0_153_14310">
				<rect width="25" height="21" fill="currentColor" transform="translate(0.623535 0.503319)" />
			</clipPath>
		</defs>
	</svg>
)
